/**
 * Description: 判断客户端类型 微信 网页 IOS ANDROID
 * Author: caojun
 * Date: 2017/7/7
 * Time: 14:40
 *
 */

export default function getSource() {
    let u = navigator.userAgent.toLowerCase();//获取判断用的对象
    let logSource = "WEI"
    if (u.match(/MicroMessenger/i) == "micromessenger") {
        logSource = "WEI"
    } else if (u.indexOf('iphone') > -1) {
        //是否在IOS浏览器打开
        logSource = "IOS"
    } else if (u.indexOf('android') > -1 || u.indexOf('linux') > -1) {
        //是否在安卓浏览器打开
        logSource = "ANDROID"
    }
    return logSource
}
